module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.description) ? _c('div', {
    staticClass: "pb-3",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.identifiers), function(id) {
    return [_c('ds-identifier-chip', {
      key: id,
      attrs: {
        "identifier": id,
        "can-remove": _vm.canRemove && !_vm.isReadOnly
      },
      on: {
        "remove": _vm.remove
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b145754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleModifier.vue
// module id = 423
// module chunks = 1